import Flickity from 'flickity';
require('flickity-imagesloaded');

export default class Slider {
    constructor(component) {
        this.component = component;
        
        this.init();
    }
    
    init() {
        const slider = new Flickity(this.component, {
            imagesLoaded: true,
            watchCSS: true,
            contain: true,
            cellAlign: 'left',
            initialIndex: this.component.getAttribute('data-slider-initial-index'),
            prevNextButtons: this.component.hasAttribute('data-slider-buttons'),
            pageDots: this.component.hasAttribute('data-slider-dots'),
            wrapAround: this.component.hasAttribute('data-slider-wrap-around'),
            cellSelector: this.component.getAttribute('data-slider-cellselector'),
            adaptiveHeight: this.component.hasAttribute('data-slider-adaptive-height'),
            arrowShape: 'M51.2,23.6l-19.6,19.4h63.4v13.8h-62.8l19.6,19.5-9.9,9.8L5,49.9,41.4,13.9l9.9,9.8Z'
        });
    }
}
